export default __webpack_public_path__ + "media/zurb/img/home/design-insight-icon-be3b91096d9c4f4c89b7725d30fa66a0.svg";